import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";
import { regex } from "../../../../../../../utils/functions/regex";
import TextFields from "@/src/components/elements/Inputs/Textfields";
import style from "./index.module.scss";
import Font from "@/src/components/base/Font";
import ButtonBase from "../../../../../../../components/elements/Button";
import Icon from "../../../../../../../components/elements/Icons/Icons";
import Snackbar from "../../../../../../../components/elements/Snackbar";
import {
  clearLoginData,
  getCaptcha,
  loginAction,
  logoutAction,
  termConditionsFetch,
} from "../../../../../../../redux/actions/login";
import Loading from "../../../../../../../components/elements/Loading";
import { useRouter } from "next/router";
import Cookies from "universal-cookie";
import { encode } from "js-base64";
import { Header } from "@/src/components/index";
import {
  getIpAddressDatas,
  sendUserTrackingDatas,
} from "@/src/redux/actions/user_tracking";
import { clickEventDatas } from "@/src/datas/clickEventDatas/loginUserTracking";
import { clickStream } from "@/src/utils/functions/clickStream";
import { generateEventData } from "@/src/utils/functions/generateEventData";
import useDevice from "@/src/hooks/general/useDevice";
import usePlatform from "@/src/hooks/general/usePlatform";
import Swipeable from "@/src/components/elements/SwipeableDrawer";
import { fetchDoLoginSingleProduct } from "@/src/services";
const SpinLoader = dynamic(
  () => import("../../../../../../../components/elements/Loaders/SpinLoader")
);

type loginDatasInput = "empty" | "true" | "false";

const Login: (props: {
  staticData: any,
  stateData: any,
  handleChangeStateData: (value: any) => void,
}) => JSX.Element = (props: {
  staticData: any;
  stateData: any;
  handleChangeStateData: (value: any) => void;
}) => {
    const numberRegex: RegExp = regex.number;
    const emailRegex: RegExp = regex.email
    const dispatch = useDispatch();
    const router = useRouter();
    const cookie = new Cookies();
    const snackbarRef = useRef<any>(null);
    const [state, setState] = useState({
      focusPN: false,
      valuePN: "",
      conditionPN: false,
      lengthPN: false,
      errorPN: "",
      focusPassword: false,
      valuePassword: "",
      lengthPasswordCondition: false,
      tipeTextFieldPassword: "password",
      focusCaptcha: false,
      valueCaptcha: "",
      conditionCaptcha: false,
      lengthCaptcha: false,
      openSnackbar: false,
      loginFailedCounter: 0,
      timerMultiplier: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      maskPassword: true,
      messageSnackbar: "",
      titleSnackbar: "",
      loginDrawer: props.stateData.loginDrawer,
      termConditionDrawer: false,
      userToken: "",
      userExpire: "",
    });

    const {
      captchaContent,
      captchaLoading,
      loginDatas,
      loadingLogin,
      termCondition,
    } = useSelector((stateContent: any) => stateContent.loginPage);
    const { ipAddressDatas } = useSelector(
      (stateIpAddress: any) => stateIpAddress.userTracking
    );

    // const router = useRouter();
    const filteredMobile = loginDatas?.data?.user?.access?.filter((item: any) =>
      item?.device?.some((dv: any) => dv?.device === "mobile")
    );
    const roleLink5 = filteredMobile?.find(
      (item: any) => item?.product === "link5"
    )?.role;

    const device: "mobile" | "desktop" | undefined = useDevice();
    const osDesktop:
      | "windows"
      | "mac"
      | "iOS"
      | "linux"
      | "android"
      | ""
      | undefined = usePlatform();
    useEffect(() => {
      dispatch(getIpAddressDatas());
    }, []);

    function removeAccess(combinedResult: any) {
      return {
        ...combinedResult,
        data: {
          ...combinedResult?.data,
          user: {
            ...combinedResult?.data?.user,
            access: null
          }
        }
      };
    }
    const clearCacheData = () => {
      caches?.keys()?.then((names) => {
        names?.forEach((name) => {
          caches?.delete(name);
        });
      });
      cookie.remove("user");
      sessionStorage.clear();
      localStorage.clear();
      console?.log("Complete Cache Cleared");
    };

    useEffect(() => {
      clearCacheData();
    }, []);

    const userTracking = (event: string) => {
      const data = Object.getOwnPropertyDescriptor(clickEventDatas, event);
      const dataStream = clickStream(
        generateEventData(data?.value, device, osDesktop, ipAddressDatas)
      );
      dispatch(
        sendUserTrackingDatas(
          dataStream,
          "f0zc4ZmPDvh5jI1lEJkv30jPHq5iGLKA8OghZEa50fQG7"
        )
      );
    };

    useEffect(() => {
      dispatch(getCaptcha({}));
      dispatch(termConditionsFetch());
    }, [loginDatas]);

    useEffect(() => {
      if (loginDatas?.length === 0) {
        cookie.remove("user");
        sessionStorage.clear();
        localStorage.clear();
      }
      // console.log("loginDatas", loginDatas);
      if (loginDatas?.status_code === 200) {
        if (typeof window !== undefined) {
          localStorage.setItem("data", JSON.stringify(loginDatas?.data?.user));
          localStorage.setItem("accesses", JSON.stringify(loginDatas?.data?.user));
        }
        if (roleLink5?.toLowerCase() === "rm") {
          console.log("TnC");
        } else if (filteredMobile?.length === 1) {
          fetchDoLoginSingleProduct(loginDatas.data.user.access[0].product_id, loginDatas?.data?.token)
            .then((res: any) => {

              const cookie = new Cookies();

              cookie.remove("user", { path: '/' });
              cookie.remove("userData", { path: '/' });

              localStorage.setItem("data", JSON.stringify(res?.data?.user));

              cookie.set("user", res?.data?.token, {
                path: "/",
                expires: new Date(res?.data?.expire),
              });

              cookie.set("userData", res?.data?.user, {
                path: "/",
                expires: new Date(res?.data?.expire),
              });
              window.location.assign(
                `${filteredMobile?.[0]?.device?.find(
                  (item: any) => item?.device === "mobile"
                )?.main_url}${filteredMobile?.[0]?.device?.find(
                  (item: any) => item?.device === "mobile"
                )?.uri
                }`
              );
            })

        } else {
          router.push("/menu");
        }
        if (loginDatas?.data?.user?.role?.toLowerCase() !== "rm") {
          cookie.set("user", loginDatas?.data?.token, {
            path: "/",
            expires: new Date(loginDatas?.data?.expire),
          });
          cookie.set("userData", removeAccess(loginDatas?.data?.user), {
            path: "/",
            expires: new Date(loginDatas?.data?.expire),
          });
          userTracking("login_success");
        }
      }
    }, [loginDatas, router]);

    let stylePersonalNumber: loginDatasInput;
    if (loginDatas?.auth?.status === "200") {
      stylePersonalNumber = "empty";
    } else if (
      !state.focusPN &&
      loginDatas?.auth?.helper_text?.personal_number === undefined &&
      loginDatas?.auth?.snackbar?.counter === undefined
    ) {
      stylePersonalNumber = "empty";
    } else if (state.focusPN && state.errorPN.length === 0) {
      stylePersonalNumber = "true";
    } else {
      stylePersonalNumber = "false";
    }

    let stylePassword: loginDatasInput;
    if (loginDatas?.auth?.status === "200") {
      stylePassword = "empty";
    } else if (
      !state.focusPassword &&
      loginDatas?.auth?.helper_text?.password?.length === undefined
    ) {
      stylePassword = "empty";
    } else if (
      !state.focusPassword &&
      loginDatas?.auth?.snackbar?.message?.length === undefined
    ) {
      stylePassword = "empty";
    } else if (
      !state.focusPassword &&
      loginDatas?.auth?.helper_text.password?.length !== 0 &&
      state.lengthPasswordCondition
    ) {
      stylePassword = "empty";
    } else if (
      !state.focusPassword &&
      loginDatas?.auth?.snackbar.message?.length !== 0 &&
      state.lengthPasswordCondition
    ) {
      stylePassword = "empty";
    } else if (state.focusPassword) {
      stylePassword = "true";
    } else {
      stylePassword = "false";
    }

    let styleCaptcha: loginDatasInput;
    if (loginDatas?.auth?.status === "200") {
      styleCaptcha = "empty";
    } else if (
      !state.focusCaptcha &&
      loginDatas?.auth?.helper_text?.captcha?.length === undefined
    ) {
      styleCaptcha = "empty";
    } else if (
      !state.focusCaptcha &&
      loginDatas?.auth?.snackbar?.message?.length === undefined
    ) {
      styleCaptcha = "empty";
    } else if (
      !state.focusCaptcha &&
      loginDatas?.auth?.helper_text.captcha?.length !== 0 &&
      state.lengthCaptcha
    ) {
      styleCaptcha = "empty";
    } else if (
      !state.focusCaptcha &&
      loginDatas?.auth?.snackbar.message?.length !== 0 &&
      state.lengthCaptcha
    ) {
      styleCaptcha = "empty";
    } else if (state.focusCaptcha) {
      styleCaptcha = "true";
    } else {
      styleCaptcha = "empty";
    }

    const handleChangePN: (e: any) => void = (e: any) => {
      setState({
        ...state,
        valuePN: e.target.value,
        conditionPN:
          numberRegex.test(e.target.value) ||
          e.target.value.length === 0 ||
          emailRegex.test(e.target.value),
        lengthPN: e.target.value.length !== 0,
        errorPN:
          numberRegex.test(e.target.value) ||
            e.target.value.length === 0 ||
            emailRegex.test(e.target.value)
            ? ""
            : // : "Format personal number harus berupa angka",
            "Format personal number atau email salah",
      });
    };
    // const handleChangeEmail: (e: any) => void = (e: any) => {
    //   setState({
    //     ...state,
    //     valuePN: e.target.value,
    //     conditionPN: e.target.value.length < 5 || emailRegex.test(e.target.value),
    //     lengthPN: e.target.value.length !== 0,
    //     errorPN: e.target.value.length < 5 || emailRegex.test(e.target.value) ? '' : 'Format email salah'
    //   })
    // }
    // PN atau Email
    const handleChangeUser: (e: any) => void = (e: any) => {
      // if (isLoginWithEmail) {
      //   handleChangeEmail(e)
      //   return
      // }
      handleChangePN(e)
    }

    const handleFocusPN: () => void = () => {
      setState({ ...state, focusPN: true });
      userTracking("personal_number");
    };

    const handleBlurPN: () => void = () => {
      setState({
        ...state,
        focusPN: false,
        // conditionPN: isLoginWithEmail
        //   ? state.valuePN.length > 0 && state.valuePN.length < 5
        //   : state.conditionPN,
        // errorPN: isLoginWithEmail && state.valuePN.length > 0 && state.valuePN.length < 5
        //   ? 'Format email salah'
        //   : state.errorPN,
      });
    };

    const conditionClear: { [key: string]: boolean } = {
      pn: state.valuePN.length !== 0,
      captcha: state.valueCaptcha.length !== 0,
    };
    const handleClearPN: () => void = () => {
      setState({ ...state, valuePN: "" });
    };

    // Password
    const handleChangePassword: (e: any) => void = (e: any) => {
      setState({
        ...state,
        valuePassword: e.target.value,
        lengthPasswordCondition: e.target.value.length !== 0,
      });
    };

    const handleFocusPassword: () => void = () => {
      setState({ ...state, focusPassword: true });
      userTracking("password");
    };

    const handleBlurPassword: () => void = () => {
      setState({ ...state, focusPassword: false });
    };

    const helperTextPassword = state.valuePassword.length === 0 &&
      state.valuePN.length > 0 &&
      state.valueCaptcha.length > 0
      ? "Mohon masukkan password terlebih dahulu"
      : ""

    // Captcha
    const handleChangeCaptcha: (e: any) => void = (e: any) => {
      setState({
        ...state,
        valueCaptcha: e.target.value,
        lengthCaptcha: e.target.value.length !== 0,
      });
    };

    const handleFocusCaptcha: () => void = () => {
      setState({ ...state, focusCaptcha: true });
      userTracking("captcha");
    };

    const handleBlurCaptcha: () => void = () => {
      setState({ ...state, focusCaptcha: false });
    };

    const handleClearCaptcha: () => void = () => {
      setState({ ...state, valueCaptcha: "" });
    };

    const handleUnMaskPassword = () => {
      setState({ ...state, maskPassword: !state.maskPassword });
    };

    const handleSubmit: (
      e: any,
      pn: string,
      password: string,
      idCaptcha: string,
      captchaValue: string
    ) => void = (
      e: any,
      pn: string,
      password: string,
      idCaptcha: string,
      captchaValue: string
    ) => {
        e.preventDefault();
        dispatch(
          loginAction({
            captcha_id: idCaptcha,
            captcha_value: captchaValue,
            password: encode(password),
            personal_number: pn,
          })
        );
        userTracking("login");
        setState({ ...state, openSnackbar: false });
      };

    const handleYesTermConditions = () => {
      // cookie.set("user", state.userToken, {
      //   path: "/",
      //   expires: new Date(state.userExpire),
      // });
      if (filteredMobile?.length === 1) {
        fetchDoLoginSingleProduct(4, state.userToken)
          .then((res: any) => {
            const cookie = new Cookies();

            cookie.remove("user", { path: '/' });
            cookie.remove("userData", { path: '/' });


            cookie.set("user", res?.data?.token, {
              path: "/",
              expires: new Date(res?.data?.expire),
            });
            cookie.set("userData", res?.data?.user, {
              path: "/",
              expires: new Date(res?.data?.expire),
            });

            localStorage.setItem("data", JSON.stringify(res?.data?.user));

            window.location.assign("/link5/rekomendasi");
          })
      } else {
        router.push("/menu");
      }
      userTracking("login_success");
    };

    const handleNoTermConditions = () => {
      dispatch(logoutAction({}, state.userToken));
      sessionStorage.clear();
      localStorage.clear();
      snackbarRef?.current?.show();
      setState({
        ...state,
        loginDrawer: true,
        termConditionDrawer: false,
        openSnackbar: true,
        titleSnackbar: "Gagal Login",
        messageSnackbar:
          "Anda perlu menyetujui terms & condition untuk menggunakan aplikasi.",
      });
    };

    const handleStoreLogin = (value: boolean) => {
      setState({
        ...state,
        loginDrawer: value,
      });
      props.handleChangeStateData({
        openLogin: value,
      });
    };

    const handleStoreTermConditions = () => {
      dispatch(logoutAction({}, state.userToken));
      sessionStorage.clear();
      localStorage.clear();
      setState({
        ...state,
        loginDrawer: true,
        termConditionDrawer: false,
      });
    };

    useEffect(() => {
      roleLink5?.toLowerCase() === "rm" &&
        setState({
          ...state,
          loginDrawer: false,
          termConditionDrawer: true,
          openSnackbar: false,
          userToken: loginDatas?.data?.token,
          userExpire: loginDatas?.data?.expire,
        });
      if (loginDatas?.status_code != null && loginDatas?.status_code !== 200) {
        snackbarRef?.current?.show();
        setState({
          ...state,
          openSnackbar: true,
          titleSnackbar: "Terjadi Kesalahan",
          messageSnackbar: loginDatas.message,
        });
        userTracking("login_error");
        dispatch(clearLoginData());
      }
    }, [loginDatas]);

    const validation =
      state.valuePN.length === 0 ||
        state.valuePassword.length === 0 ||
        state.valueCaptcha.length === 0 ||
        state.errorPN.length !== 0
        ? false
        : true;

    function resetFormState() {
      setState({
        ...state,
        valuePN: '',
        valuePassword: '',
        valueCaptcha: '',
        errorPN: ''
      })
    }

    // console.log("loginDatas", loginDatas);

    return (
      <>
        {/* Login Drawer */}
        <Swipeable
          from="bottom"
          borderRadius="16px 16px 0 0"
          headerHeight={"24px"}
          state={state.loginDrawer}
          handlingStore={(value: boolean) => handleStoreLogin(value)}
        >
          <div className={style.heading}>
            <Font variant="subtitle-6-bold" color="blue1" align="center">
              {props.staticData.title}
            </Font>
            <Font
              variant="subtitle-2-medium"
              color="gray-2"
              align="center"
            >
              {props.staticData.description}
            </Font>
          </div>
          <div className={style.form_div}>
            <form
              onSubmit={
                validation
                  ? (e: any) =>
                    handleSubmit(
                      e,
                      state.valuePN,
                      state.valuePassword,
                      captchaContent?.data?.id,
                      state.valueCaptcha
                    )
                  : (e) => e.preventDefault()
              }
            >
              <TextFields
                adornmentId="Adornment_Reset_Input_PN"
                id={"TextField_Underline_Pn"}
                label={props?.staticData?.personal_number?.label}
                type="text"
                value={state.valuePN}
                onChange={handleChangeUser}
                onFocus={handleFocusPN}
                onBlur={handleBlurPN}
                placeholder={props?.staticData?.personal_number?.placeholder}
                maxLength={props?.staticData?.personal_number?.max}
                onEndAdornment={handleClearPN}
                endAdornmentCondition={conditionClear.pn}
                helperText={
                  loginDatas?.length !== 0
                    ? loginDatas?.auth?.helper_text?.personal_number
                    : state.errorPN
                }
                helperTextColor="red"
                helperCondition={
                  loginDatas?.auth?.helper_text?.personal_number?.length !== 0 ||
                  state?.errorPN?.length !== 0
                }
                condition={stylePersonalNumber}
                endAdornment={
                  <div id={"TrailingIcon_Clear"}>
                    <Icon
                      mode="circle"
                      backgroundColor="dusty-gray"
                      select="clear"
                      size="18"
                      color="#fff"
                      rotate="0"
                    />
                  </div>
                }
              />
              <TextFields
                adornmentId="Adornment_Show_Hide_Password"
                id={"TextField_underline_Password"}
                label={props?.staticData?.password?.label}
                type={state.maskPassword ? "password" : "text"}
                value={state.valuePassword}
                onChange={handleChangePassword}
                onFocus={handleFocusPassword}
                onBlur={handleBlurPassword}
                placeholder={props?.staticData?.password?.placeholder}
                maxLength={props?.staticData?.password?.max}
                onEndAdornment={handleUnMaskPassword}
                endAdornmentCondition={true}
                helperText={helperTextPassword}
                helperTextColor="red"
                helperCondition={!state.lengthPasswordCondition}
                condition={stylePassword}
                endAdornment={
                  <div
                    id={
                      state.maskPassword
                        ? "TrailingIcon_ShowPassword"
                        : "Trailing_HidePassword"
                    }
                  >
                    <Icon
                      select={state.maskPassword ? "eye_close" : "eye_open"}
                      size="18"
                      color="#E1E4EA"
                      rotate="0"
                    />
                  </div>
                }
              />
              <TextFields
                adornmentId="Adornment_Reset_Input_Captcha"
                id={"TextField_Underline_Capcha"}
                label={props?.staticData?.captcha?.label}
                type="text"
                value={state.valueCaptcha}
                onChange={handleChangeCaptcha}
                onFocus={handleFocusCaptcha}
                onBlur={handleBlurCaptcha}
                placeholder={props?.staticData?.captcha?.placeholder}
                maxLength={props?.staticData?.captcha?.max}
                onEndAdornment={handleClearCaptcha}
                endAdornmentCondition={conditionClear.captcha}
                helperText={
                  loginDatas?.length !== 0
                    ? loginDatas?.auth?.helper_text?.captcha
                    : ""
                }
                helperTextColor="red"
                condition={styleCaptcha}
                endAdornment={
                  <Icon
                    mode="circle"
                    backgroundColor="dusty-gray"
                    select="clear"
                    size="18"
                    color="#fff"
                    rotate="0"
                  />
                }
              />

              {/* Image Captcha */}
              {/* HARUS DIHANDLE SAAT CAPTCHA GAGAL DI LOAD, JANGAN LOADING AJA */}
              <div className={style.wrapper}>
                {!captchaLoading &&
                  captchaContent?.data?.base64 !== undefined ? (
                  <div className={style.image_wrapper}>
                    <img
                      src={captchaContent?.data?.base64}
                      alt="captcha"
                      style={{ width: "100%", height: "62px" }}
                    />
                  </div>
                ) : !captchaLoading &&
                  captchaContent?.data?.base64 === undefined ? (
                  <div className={style.error_captcha_wrapper}>
                    <div>
                      {`Loading captcha bermasalah. `}
                      <span
                        onClick={() => dispatch(getCaptcha({}))}
                        className={style.error_captcha_refresh_anchor}
                      >
                        {`Refresh`}
                      </span>
                    </div>
                  </div>
                ) : (
                  <Loading width={310} height={62} />
                )}
              </div>

              {/* button login */}
              <ButtonBase
                // id={'bribrain-button-login'}
                id={"Button_Primary_Login"}
                text={
                  loadingLogin
                    ? props?.staticData?.login_button?.loading_text
                    : props?.staticData?.login_button?.default_text
                }
                type={props?.staticData?.login_button?.type}
                variant={props?.staticData?.login_button?.variant}
                size={props?.staticData?.login_button?.size}
                enabled={validation}
              >
                <>{loadingLogin && <SpinLoader />}</>
              </ButtonBase>
            </form>
          </div>
        </Swipeable>

        {/* Term & Conditions */}
        <Swipeable
          from="bottom"
          borderRadius="16px 16px 0 0"
          headerHeight={"24px"}
          state={state.termConditionDrawer}
          handlingStore={() => handleStoreTermConditions()}
        >
          <div className={style.heading_tnc}>
            <img
              src={`${process.env.CDN_URL}/images/main/mobile/warning2-icon.webp`}
              alt=""
              width="24px"
              height="24px"
            />
            <Font variant="subtitle-6-bold" color="mine_shaft">
              PERHATIAN
            </Font>
          </div>
          <div className={style.container_term_condition} dangerouslySetInnerHTML={{ __html: termCondition?.data }} />
          <div className={style.button_wrapper}>
            <ButtonBase
              id={"Button_Primary_Setuju"}
              variant={"primary"}
              text={"Setuju"}
              onClick={() => handleYesTermConditions()}
            />
            <ButtonBase
              id={"Button_Secondary_TidakSetuju"}
              variant={"secondary"}
              text={"Tidak Setuju"}
              onClick={() => handleNoTermConditions()}
            />
          </div>
        </Swipeable>

        {/* snackbar */}
        <Snackbar
          ref={snackbarRef}
          title={state.titleSnackbar}
          message={state.messageSnackbar}
          backgroundColor={"#eb5757"}
          timer={4000}
          autoClose
        />
      </>
    );
  };

export default Login;
